import { useMemo } from "react";

import debounce from "lodash/debounce";

import { RVInput, type RVInputProps } from "../RVInput/RVInput";

export type RVDebouncedInputProps = RVInputProps & {
    /**
     * Debounce delay in ms
     *
     * @default 700
     */
    debounceMs?: number;
};

type Action = (value: string) => void;

/**
 * RVDebouncedInput
 *
 * A search input component with debounced change events.
 * Useful for filtering lists or tables without firing on every keystroke.
 *
 * @param {RVDebouncedInputProps} props - Component props
 * @returns {JSX.Element}
 */
export function RVDebouncedInput({ action, debounceMs = 700, ...rest }: RVDebouncedInputProps): JSX.Element {
    const inputAction = useMemo(() => {
        return debounce<Action>((value) => action(value), debounceMs);
    }, [action, debounceMs]);

    return <RVInput action={inputAction} onPressEnterAction={action} {...rest} />;
}
